<template>
    <div id="company-view-buttons">
        <!-- Save & Cancel Button -->
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button class="mt-2" @click="submit" color="secondary" :disabled="loading">{{
                        $t('ConfirmAndSubmit')
                      }}</vs-button>
                    <vs-button v-if="showResetButton" class="ml-4 mt-2" @click="reset">{{ $t('ResetForm') }}</vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "FormOrderFormButtons",
    props: {
      loading: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        showResetButton: false,
      }
    },
    methods: {
      submit() {
        this.$emit('submit');
      },
      reset() {
        this.$emit('reset');
      }
    }
  }
</script>

<style scoped>

</style>
